var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrap"},[_c('h2',[_vm._v("誠に申し訳ございません。")]),_c('p',[_vm._v("ただいま、システムメンテナンスのため、"),_c('br'),_vm._v("本サイトをご利用いただけません。")]),_c('p',[_vm._v("「メンテナンス終了時間」"),_c('br'),_vm._v("2020年10月8日（木）12:00 予定")])])
}]

export { render, staticRenderFns }